import { createSvgIcon } from '@mui/material/utils';

export const HomeIcon = createSvgIcon(
    <>
        <path d='M 14.443 1.008 C 13.117 -0.336 10.918 -0.336 9.59 1.008 L 3.106 7.569 C 2.734 7.947 2.483 8.423 2.387 8.939 C 1.599 13.147 1.542 17.455 2.215 21.683 L 2.454 23.179 C 2.529 23.652 2.945 24 3.433 24 L 7.963 24 C 8.337 24 8.639 23.704 8.639 23.337 L 8.639 14.069 L 15.395 14.069 L 15.395 23.337 C 15.395 23.704 15.697 24 16.07 24 L 20.601 24 C 21.089 24 21.505 23.652 21.579 23.179 L 21.818 21.683 C 22.491 17.455 22.434 13.147 21.646 8.939 C 21.55 8.423 21.299 7.947 20.927 7.569 L 14.443 1.008 Z' />
    </>,
    'HomeIcon'
);
